import script from "./MyDataGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./MyDataGrid.vue?vue&type=script&setup=true&lang=js"

import "./MyDataGrid.vue?vue&type=style&index=0&id=f666ee4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f666ee4a"]])

export default __exports__